import { render } from "./NotificationCard.vue?vue&type=template&id=03f645c9&scoped=true"
import script from "./NotificationCard.vue?vue&type=script&lang=js"
export * from "./NotificationCard.vue?vue&type=script&lang=js"

import "./NotificationCard.vue?vue&type=style&index=0&id=03f645c9&scoped=true&lang=css"

import exportComponent from "/var/www/zaytoon-sudani-frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-03f645c9"]])

export default __exports__